getUrlParam = function (parameter) {
  var url_string = window.location.href;
  var url = new URL(url_string);
  var parValue = url.searchParams.get(parameter);
  return parValue;
};

insertUrlParam = function (key, value) {
  key = encodeURI(key); value = encodeURI(value);

  var kvp = document.location.search.substr(1).split('&');
  if (kvp == '') {
    document.location.search = '?' + key + '=' + value;
  }
  else {
    var i = kvp.length; var x; while (i--) {
      x = kvp[i].split('=');

      if (x[0] == key) {
        x[1] = value;
        kvp[i] = x.join('=');
        break;
      }
    }
    if (i < 0) { kvp[kvp.length] = [key, value].join('='); }
    //this will reload the page, it's likely better to store this until finished
    // document.location.search = kvp.join('&');
    window.history.replaceState(null, null, location.protocol + '//' + location.host + location.pathname + "?" + kvp.join('&'));
  }
}
